import styled from 'styled-components';
import { IconButton } from 'modules/IconButton';
export const StyledIconButton = styled(IconButton) `
  padding: 0;
  margin: 0;
`;
